import { has } from 'lodash';
import * as types from './types';

const INITIAL_STATE = {
  error: null,
  loading: false,
  configLoading: false,
  reportHasData: true,
  configSaved: false,
  enabled: false,
  exportSchedule: '',
  fileName: '',
  sites: [],
  exportSites: [],
  bedsCode: null,
  includeEligibilityTypeCode: false,
};

export default (state = INITIAL_STATE, { payload, type }) => {
  switch (type) {
    case types.NEW_YORK_SIRS_EXPORT_SET_REPORT_HAS_DATA:
      return { ...state, reportHasData: payload };
    case types.NEW_YORK_SIRS_EXPORT_LOADING:
      return { ...state, loading: payload };
    case types.NEW_YORK_SIRS_EXPORT_CONFIG_LOADING:
      return { ...state, configLoading: payload };
    case types.NEW_YORK_SIRS_EXPORT_ERROR:
      if (
        has(payload, 'response.data.Errors') &&
        payload.response.data.Errors.length > 0
      ) {
        const error = payload.response.data.Errors[0];
        return {
          ...state,
          error,
        };
      }
      return {
        ...state,
        fetchError: {
          Title: 'Error',
          Message:
            'An error occurred while retrieving the SIRS export. Please try again',
        },
      };
    case types.NEW_YORK_SIRS_EXPORT_CLEAR_ERROR:
      return { ...state, error: payload };
    case types.NEW_YORK_SIRS_EXPORT_GET_EXPORT_CONFIG:
      return {
        ...state,
        enabled: payload.Enabled,
        exportSchedule: payload.ExportSchedule,
        fileName: payload.FileName,
        exportSites: payload.SiteIds,
        bedsCode: payload.BedsCode,
        includeEligibilityTypeCode: payload.IncludeEligibilityTypeCode,
      };
    case types.NEW_YORK_SIRS_EXPORT_RESET_EXPORT_CONFIG:
      return {
        ...state,
        enabled: false,
        exportSchedule: '',
        fileName: '',
        exportSites: [],
        bedsCode: null,
      };
    case types.NEW_YORK_SIRS_EXPORT_SET_CONFIG_DID_SAVE:
      return {
        ...state,
        configSaved: payload,
      };
    case types.NEW_YORK_SIRS_EXPORT_SET_EXPORT_CONFIG:
      return {
        ...state,
        configSaved: true,
      };
    case types.NEW_YORK_SIRS_EXPORT_GET_SITES:
      return {
        ...state,
        sites: payload,
      };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/pages/newyorksirsexport/state/export/reducer.js